import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';

const json = {
  1: {
    unit: 'Unit 11',
    id: 'WB4-V2-U11-P78-E1',
    audio: '',
    video: '',
    component: UI,
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page78/2.jpg' },
      ]
    ]
  },
  2: { // Exercise num
    unit: 'Unit 11',
    id: 'WB4-V2-U11-P78-E2',
    audio: 'img/FriendsPlus/Page78/Audio/audio-e2-p78.mp3',
    video: '',
    component: T6,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page78/E2/Key/answerKey.png',
    inputSize: 115,
    // titleImage: "img/FriendsPlus/Page60/E1/1.jpg",
    titleQuestion: [{ num: '2', title: 'Don’t look at the reading. Listen and write answers to the questions. <headphone name="22" src="img/FriendsPlus/Page78/Audio/tieude-e2-p78.mp3"></headphone>', color: "#5B5A5D" }],
    questionImage: [],
    questions: [
      {
        title: `
        <div>
          <div> <img src='img/FriendsPlus/Page78/E2/1.jpg' /> </div>

          <div style=" position: relative; ">
            <div> <img src='img/FriendsPlus/Page78/E2/2.jpg' /> </div>
            <div style=" position: absolute; top: 68px; left: 491px "><input id='0' /></div>
            <div style=" position: absolute; top: 136px; left: 433px "><input id='1' /></div>
            <div style=" position: absolute; top: 204px; left: 434px "><input id='2' /></div>
          </div>
        </div>

        
        `,
        answer: [
          "four",
          "eggs",
          "milk",
        ],
      },
    ],
  },




}
export default json;